export default "__VITE_ASSET__DkGwVhm9__"